import { CartLinesUpdateEvent } from '@shopify/events';
(() => {
 document.addEventListener('click', event => {
  const tab = event.target.closest('[data-s30-family]');
  if (tab) {
   const section = tab.closest('[data-s30-families]');
   section.querySelectorAll('[data-s30-family]').forEach(button => {
    const active = button === tab; button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));
   });
   section.querySelectorAll('[data-s30-panel]').forEach(panel => panel.hidden = panel.dataset.s30Panel !== tab.dataset.s30Family);
  }
 });
 document.addEventListener('submit',async event => {
  const form = event.target.closest('[data-s30-quick-form]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.busy) return;
  form.dataset.busy = 'true';
  const button=form.querySelector('button'), status=form.querySelector('[role=status]'), original=button.textContent;
  button.disabled=true; button.textContent='Ajout…';status.hidden=true;
  const root=(window.Shopify?.routes?.root || '/');
  const variantId=String(new FormData(form).get('id'));
  const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
  const deferred=CartLinesUpdateEvent.createPromise();
  // Native cart, header count and drawer all subscribe to this event.
  form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:variantId,quantity:1}],promise:deferred.promise}));
  try {
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}],sections,sections_url:location.pathname})});
   const result=await response.json();
   if (!response.ok || result.status) throw Error(result.description || 'Cet article ne peut pas être ajouté.');
   status.replaceChildren(document.createTextNode('Ajouté au panier. '));
   const link=document.createElement('a');link.href=root+'cart';link.textContent='Voir mon panier';status.append(link);status.hidden=false;
   const cartResponse=await fetch(root+'cart.js',{cache:'no-store'});
   if (!cartResponse.ok) throw Error('Article ajouté. Le panier sera actualisé à son ouverture.');
   const cart=await cartResponse.json();
   deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:form.id || 's30-quick-add',itemCount:1,sections:result.sections,didError:false}});
  } catch (error) {
   deferred.reject(error);
   status.replaceChildren(document.createTextNode((error.message || 'Ajout impossible.')+' Vérifiez votre panier avant de réessayer. '));
   const link=document.createElement('a');link.href=root+'cart';link.textContent='Voir mon panier';status.append(link);status.hidden=false;
  } finally {delete form.dataset.busy;button.disabled=false;button.textContent=original;}
 });
})();

// Promote the product's own specifications and inspiration above the bundle.
